import { useCallback, useEffect, useState } from "react";
import {
    getUserData,
} from "../../Actions/common";
import { allLoginSessionsAction } from "../../Actions/loginSessions";
import BreadcrumbsComponent from "../../components/Common/Breadcrumbs";
import {
    ITEMS_PER_PAGE_OPTIONS
} from "../../config";
import { formatDateTime } from "../Common/DateFormat";
import CustomSnackbar from "../Common/snackBar";
import renderStatusBadge from "../../utils/badges";
import DataTable from "../../components/DataTable/DataTable";

const LoginSessionsSection = ({ merchantId }) => {
    const [totalRecords, setTotalRecords] = useState(0);
    const [loading, setLoading] = useState(true);
    const [snackbar, setSnackbar] = useState({
        open: false,
        message: "",
        severity: "success",
    });
    const [currentPage, setCurrentPage] = useState(1);
    const [shouldFetchData, setShouldFetchData] = useState(1);
    const [whiteListIpsData, setWhiteListIpsData] = useState([]);
    const [anchorEl, setAnchorEl] = useState(null);
    const isMenuOpen = Boolean(anchorEl);
    const [selectedRowsPerPage, setSelectedRowsPerPage] = useState(
        ITEMS_PER_PAGE_OPTIONS[0]
    );
    const userData = localStorage.getItem("userData") ? getUserData() : null;
    const [startDate, setStartDate] = useState(new Date().toISOString());
    const [endDate, setEndDate] = useState(new Date().toISOString());

    const [filterValues, setFilterValues] = useState({
        dateFilter: "today",
    });

    const handleCloseSnackbar = () => {
        setSnackbar({ ...snackbar, open: false });
    };

    const getTemplateData = useCallback(async () => {
    setLoading(true);
    await allLoginSessionsAction(
        startDate,
        endDate,
        selectedRowsPerPage,
        currentPage
    )
        .then((res) => {
            const { rows, count } = res.data.data;
            if (res?.data.status === 202) {
                setSnackbar({
                    open: true,
                    message: res?.data?.message,
                    severity: "info",
                });
                return;
            }
            setWhiteListIpsData(rows);
            setTotalRecords(count);
            setLoading(false);
        })
        .catch((error) => {
            setSnackbar({
                open: true,
                message: error.response.data.message,
                severity: "error",
            });
        });
    setLoading(false);
    }, [startDate, endDate, selectedRowsPerPage, currentPage]);

    // Now use it in useEffect with clean dependencies
    useEffect(() => {
        if (shouldFetchData) {
            getTemplateData();
            setShouldFetchData(0);
        }
    }, [shouldFetchData, getTemplateData]);

    const columns = [
        {
            field: "status",
            headerName: "Status",
            renderCell: ({ row }) => {
                const statusMap = {
                    OK: { text: "OK", status: "success" },
                    ERR: { text: "Error", status: "error" },
                };

                const { text, status } =
                    statusMap[row.status] || {
                        text: "Unknown",
                        status: "default",
                    };

                return renderStatusBadge({
                    status,
                    title: text,
                });
            },
        },
        {
            field: "device",
            headerName: "Device",
        },
        {
            field: "ipAddress",
            headerName: "IP Address",
            renderCell: ({ row }) => row.ipAddress || "-",
        },
        {
            field: "createdAt",
            headerName: "Time",
            renderCell: ({ row }) =>
                formatDateTime(
                    row.createdAt,
                    true,
                    userData?.dateFormat || "",
                    userData?.timeFormat || "",
                    userData?.timeZone || ""
                ),
        },
    ];

    const filters = [
        {
            type: "select",
            name: "dateFilter",
            label: "Date Range",
            defaultValue: "today",
            options: [
                { label: "Today", value: "today" },
                { label: "Yesterday", value: "yesterday" },
                { label: "Last 7 Days", value: "last7days" },
                { label: "Last 15 Days", value: "last15days" },
                { label: "Last 30 Days", value: "last30days" },
            ],
        },
    ];

    const handleFilterApply = (values) => {
        setFilterValues(values);

        const option = values.dateFilter;

        const today = new Date();
        let newStartDate;
        let newEndDate;

        if (option === "today") {
            newStartDate = new Date(today);
            newEndDate = new Date(today);
        } else if (option === "yesterday") {
            const yesterday = new Date(today);
            yesterday.setDate(today.getDate() - 1);
            newStartDate = yesterday;
            newEndDate = yesterday;
        } else if (option === "last7days") {
            newStartDate = new Date(today);
            newStartDate.setDate(today.getDate() - 6);
            newEndDate = today;
        } else if (option === "last15days") {
            newStartDate = new Date(today);
            newStartDate.setDate(today.getDate() - 14);
            newEndDate = today;
        } else if (option === "last30days") {
            newStartDate = new Date(today);
            newStartDate.setDate(today.getDate() - 29);
            newEndDate = today;
        }

        setStartDate(newStartDate.toISOString());
        setEndDate(newEndDate.toISOString());

        setCurrentPage(1);
        setShouldFetchData(1);
    };

    const handleFilterReset = () => {
        const today = new Date();

        setFilterValues({
            dateFilter: "today",
        });

        setStartDate(today.toISOString());
        setEndDate(today.toISOString());

        setCurrentPage(1);
        setShouldFetchData(1);
    };

    return (
        <div id="kt_content_container">
            <BreadcrumbsComponent />
            {/* <div className="row g-5 mt-0">
                <div className="col-12">
                    <div className="card">
            
            {/* </div>
                    </div>
                </div>
            </div> */}

            {/* {openModal ? (
                <AddEditIpBlocked
                    getIpData={whiteListIpsData}
                    open={openModal}
                    handleClose={handleCloseModal}
                    ipDataById={ipDataById}
                    setSnackbar={setSnackbar}
                />
            ) : null} */}

            <DataTable
                columns={columns}
                rows={whiteListIpsData}
                loading={loading}
                totalCount={totalRecords}
                page={currentPage}
                pageSize={selectedRowsPerPage}
                filters={filters}
                filterValues={filterValues}
                getRowId={(row) => row.id}
                onFilterApply={handleFilterApply}
                onFilterReset={handleFilterReset}
                onPageChange={(page) => {
                    setCurrentPage(page);
                    setShouldFetchData(1);
                }}
                onPageSizeChange={(size) => {
                    setSelectedRowsPerPage(size);
                    setCurrentPage(1);
                    setShouldFetchData(1);
                }}
            />

            <CustomSnackbar
                open={snackbar.open}
                message={snackbar.message}
                severity={snackbar.severity}
                onClose={handleCloseSnackbar}
            />
        </div>
    );
};

export default LoginSessionsSection;
